module.exports = __webpack_public_path__ + "img/comment.3d014066.svg";